import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { GlobalSeguridad } from '@seguridad';

@Injectable({
  providedIn: 'root'
})
export class ServicioCarruselService {
  header: any = {};
  constructor(
    private http: HttpClient,
    private seguridadGlobal: GlobalSeguridad
  ) {this.header = { "Content-Type": "application/json", "Content-Types": this.seguridadGlobal.atributoSesion }; }

  getServicioEnviarCargaMasiva(fd: FormData): Observable<any> {
      return this.http.post(
      JSON.parse(sessionStorage.getItem('webConfig'))["urlServicioPizarra"]+"/FUNDatosCache/ConsultarInformacionCache", fd,
      //httpOptions
      {headers: new HttpHeaders(this.header)}
    );
  }

  getServicioSigmaConsulta(sistema, idFuncion, filtro, datosPeticion): Observable<any> {
    this.seguridadGlobal.validarSesion();
    return this.http.post(
      JSON.parse(sessionStorage.getItem('webConfig'))["servicioFw"]+"/FUNSigmaConsulta/ObtenerInformacion",
      {
        sistema: sistema,
        idFuncion: idFuncion,
        filtro: filtro,
        datosPeticion: datosPeticion
      },
      //httpOptions
      {headers: new HttpHeaders(this.header)}
    );
  }

  getServicioObtenerInformacionCache(sistema, idObjetoPizarra, filtro, datosPeticion): Observable<any> {
    this.seguridadGlobal.validarSesion();
    return this.http.post(
      JSON.parse(sessionStorage.getItem('webConfig'))["urlServicioPizarra"]+"/FUNDatosCache/ConsultarInformacionCache",
      {
        sistema: sistema,
        idObjetoPizarra: idObjetoPizarra,
        filtro: filtro,
        datosPeticion: datosPeticion

      },
      //httpOptions
      {headers: new HttpHeaders(this.header)}
    );
  }

  getServicioRealizarAccion(sistema, nombreObjeto, jsonDatos, jsonDatosPeticion, accion, url): Observable<any> {
    this.seguridadGlobal.validarSesion();
    let urlWebConfig="";
    if(url == "TNC"){
      urlWebConfig=JSON.parse(sessionStorage.getItem('webConfig'))["urlServicioTNC"]+"/FUNTNC/RealizarAccion";
    }else if(url == "TRAMITES"){
      urlWebConfig=JSON.parse(sessionStorage.getItem('webConfig'))["urlServicioTramites"]+"/FUNTramites/RealizarAccion";
    }else if(url == "SEGUIMIENTO"){
      urlWebConfig=JSON.parse(sessionStorage.getItem('webConfig'))["urlServicioSeguimiento"]+"/FUNSeguimiento/RealizarAccion";
    }else if(url == "TNCAdministracion"){
      urlWebConfig=JSON.parse(sessionStorage.getItem('webConfig'))["urlServicioTNC"]+"/FUNTNCAdministracion/RealizarAccion";
    }
    return this.http.post(
      urlWebConfig,
      {
        sistema: sistema,
        nombreObjeto: nombreObjeto,
        jsonDatos: jsonDatos,
        jsonDatosPeticion: jsonDatosPeticion,
        accion: accion
      },
      //httpOptions
      {headers: new HttpHeaders(this.header)}
    );
  }

  getServicioRealizarAccionImagen(fd:FormData, url): Observable<any> {
    this.seguridadGlobal.validarSesion();
    let urlWebConfig="";
     if(url == "TNC"){
      urlWebConfig=JSON.parse(sessionStorage.getItem('webConfig'))["urlServicioTNC"]+"/FUNTNC/RealizarAccion";
    }else if(url == "TRAMITES"){
      urlWebConfig=JSON.parse(sessionStorage.getItem('webConfig'))["urlServicioTramites"]+"/FUNTramites/RealizarAccion";
    }else if(url == "SEGUIMIENTO"){
      urlWebConfig=JSON.parse(sessionStorage.getItem('webConfig'))["urlServicioSeguimiento"]+"/FUNSeguimiento/RealizarAccion";
    }else if(url == "TNCAdministracion"){
      urlWebConfig=JSON.parse(sessionStorage.getItem('webConfig'))["urlServicioTNC"]+"/FUNTNCAdministracion/RealizarAccion";
    }
    return this.http.post(
      urlWebConfig,
      fd,
      //httpOptions
      {headers: new HttpHeaders({ "Content-Types":this.seguridadGlobal.atributoSesion})}
    );
  }

  subirArchivo(fd): Observable<any> {
    this.seguridadGlobal.validarSesion();
    return this.http.post(
      JSON.parse(sessionStorage.getItem('webConfig'))["servicioFw"]+"/FUNArchivo/SubirArchivosFtp",
      fd,
      {headers: new HttpHeaders({ "Content-Types":this.seguridadGlobal.atributoSesion})}
    );
  }
}
